import React, { useState, useEffect } from "react";
import "./ProjectXModal.scss";
import { useSelector } from "react-redux";
import axiosInstance from "../../utils/axiosInstance";

const ProjectXModal = () => {
    const [isOpen, setIsOpen] = useState(false);
    const { idToken } = useSelector((state) => state.auth);

    useEffect(() => {
        // Only show if the user is authenticated and hasn't seen the modal yet
        if (idToken) {
            const checkAccountAndShowModal = async () => {
                try {
                    const res = await axiosInstance.get(`account/get-active-alphatics-account/`, {
                        headers: {
                            Authorization: `Bearer ${idToken}`,
                        },
                    });

                    if (res?.data) {
                        console.log(res?.data, "res?.datares?.data")
                        // Check if data contains an account (handling array, paginated results, or object)
                        const hasAccount = res.data.length;

                        if (hasAccount) {
                            setIsOpen(true);
                        }
                    }
                } catch (error) {
                    console.error("Error fetching active alphatics account:", error);
                }
            };

            checkAccountAndShowModal();
        }
    }, [idToken]);

    const handleClose = () => {
        setIsOpen(false);
    };

    if (!isOpen) return null;

    return (
        <div className="projectx-modal-overlay">
            <div className="projectx-modal-container">
                <div className="modal-header">
                    <p>Important Update</p>
                    <span onClick={handleClose}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                        >
                            <circle
                                cx="12"
                                cy="12"
                                r="8.4"
                                stroke="white"
                                strokeWidth="1.2"
                            />
                            <path
                                d="M16 8L8 16"
                                stroke="white"
                                strokeWidth="1.2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M8 8L16 16"
                                stroke="white"
                                strokeWidth="1.2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </span>
                </div>

                <div className="modal-body">
                    <p className="description">
                        As previously communicated, ProjectX is no longer available.
                        <br />
                        <br />
                        Please select how you would like to continue trading here at Alpha
                        Futures. Our team has been working tirelessly around the clock to
                        bring our traders their new favorite platform, Alpha Trader. It is
                        not quite ready yet, but we want to give you the option to be one of
                        the first users on it once available (up to one week).
                        <br />
                        <br />
                        Or, if you would rather continue with Tradovate Prop, we will get you
                        transferred over in the same business day.
                        <br />
                        <br />
                        Step 1: Go to dashboard
                        <br />
                        Step 2: Select Project X account
                        <br />
                        Step 3: Select "Account Info" on ACTIVE account
                        <br />
                        Step 4: Select Switch Platform
                        <br />
                        Step 5: Choose platform
                        <br />
                        <br />
                        Thank you for trading with us!
                    </p>
                    <div className="submit-btn-container">
                        <button
                            className="standard-button"
                            style={{ width: "100%", padding: "12px" }}
                            onClick={handleClose}
                        >
                            Acknowledge & Close
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectXModal;
